import type { IModalProgressConfig, TypeBuildReturn } from './types';

import { merge } from '../../../helper';

import addClass from '../../../general/class/addClass';
import isEmptyObject from '../../../general/isEmpty/isEmptyObject';

import exLanguage from '../../../language';
import * as exElement from '../../../utils/element';

import * as exProgress from '../../progress';
import * as exModal from '../modal';

// ----------------------------------------------------------------------------

function create(config: IModalProgressConfig = {}): TypeBuildReturn {
    // Default Config
    const defConfig: IModalProgressConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Elements
    const elements = {} as TypeBuildReturn;

    // ------------------------------------------------------------------------

    // Create element (modal)
    const modal = exModal.start({
        merge: defConfig,
        attr: {
            id: 'modal-progress',
        },
        modalDialog: {
            class: {
                add: 'modal-dialog-centered',
            },
        },
        allowDismiss: false,
        backdrop: 'static',
        destroy: true,
    });
    elements.element = modal.element;
    elements.modal = modal;

    // ------------------------------------------------------------------------

    // Create element (label)
    const elLabel = exElement.create({
        merge: defConfig.label,
        tag: 'label',
        class: {
            new: 'form-label',
        },
        html: exLanguage.line('general.loading') ?? 'Loading...',
    });
    modal.child(elLabel);
    elements.label = elLabel;

    // ------------------------------------------------------------------------

    // Create element (progress)
    const progress = exProgress.create({
        merge: defConfig.progress,
        progressBar: {
            style: {
                width: '100%',
            },
        },
        striped: true,
        animated: true,
    });
    modal.child(progress.element);
    elements.progress = progress;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: TypeBuildReturn, config: IModalProgressConfig = {}): void {
    // If using progress
    if (!isEmptyObject(config.progress)) {
        // If using container
        if (config.progress?.container?.parent) {
            addClass(elements.element, 'modal-inside');
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
